<svg
  width="11"
  height="10"
  viewBox="0 0 11 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.33325 9.16671L9.66659 0.833374M9.66659 0.833374H1.33325M9.66659 0.833374V9.16671"
    stroke="white"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
